import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
    notifyCenterDisabledTarifaPlus (params) {
        return client().post('Centers/NotifyCenterDisabledTarifaPlus', params)
    }
}


// WEBPACK FOOTER //
// ./src/repositories/CenterRepository.js